import gql from 'graphql-tag';

export const MARK_WORK_ITEMS_VIEWED_MUTATION = gql`
  mutation MarkWorkItemsViewedMutation($workItemViews: [JSONObject!]!, $specKey: String!) {
    success: markWorkItemsViewed(workItemViews: $workItemViews, specKey: $specKey)
  }
`;
